// extracted by mini-css-extract-plugin
export default {"Pages":"MPages_Pages__-EH-4","depth2":"MPages_depth2__33Soa","noti":"MPages_noti__ak6Y4","subtitle":"MPages_subtitle__m5ltV"};